var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFunny(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.991 0.5C4.023 0.5 0 4.532 0 9.5C0 14.468 4.023 18.5 8.991 18.5C13.968 18.5 18 14.468 18 9.5C18 4.532 13.968 0.5 8.991 0.5ZM9 16.7C5.022 16.7 1.8 13.478 1.8 9.5C1.8 5.522 5.022 2.3 9 2.3C12.978 2.3 16.2 5.522 16.2 9.5C16.2 13.478 12.978 16.7 9 16.7ZM12.15 8.6C12.897 8.6 13.5 7.997 13.5 7.25C13.5 6.503 12.897 5.9 12.15 5.9C11.403 5.9 10.8 6.503 10.8 7.25C10.8 7.997 11.403 8.6 12.15 8.6ZM5.85 8.6C6.597 8.6 7.2 7.997 7.2 7.25C7.2 6.503 6.597 5.9 5.85 5.9C5.103 5.9 4.5 6.503 4.5 7.25C4.5 7.997 5.103 8.6 5.85 8.6ZM9 14.45C10.827 14.45 12.42 13.451 13.275 11.975C13.446 11.678 13.23 11.3 12.879 11.3H5.121C4.779 11.3 4.554 11.678 4.725 11.975C5.58 13.451 7.173 14.45 9 14.45Z",
    fill: "#314DDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunny);
export default __webpack_public_path__ + "static/media/funny.8c650592420bb5c27e80f042a09b57e4.svg";
export { ForwardRef as ReactComponent };